import { render, staticRenderFns } from "./edit-VLIS.vue?vue&type=template&id=44f64cc2&scoped=true&"
import script from "./edit-VLIS.vue?vue&type=script&lang=js&"
export * from "./edit-VLIS.vue?vue&type=script&lang=js&"
import style0 from "./edit-VLIS.vue?vue&type=style&index=0&id=44f64cc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f64cc2",
  null
  
)

export default component.exports